export default "__VITE_ASSET__db745821__"